import Vue, { ComponentOptions } from 'vue'

import Stepper from './stepper/stepper.vue'

export default {
  components: { Stepper },
} as ComponentOptions<Vue>
